module.exports = __webpack_public_path__ + "static/media/16UNODC15.2e042c2c.jpg";